import React, {useContext, useEffect, useState} from "react"
import {BloodPress, BloodPressCss, BMI, BmiCss} from "../form/rumus"
import {Tab, TabList, TabPanel, Tabs} from "react-tabs"
import Subjektif from "./form/Subjektif"
import Objektif from "./form/Objektif"
import Assesment from "./form/Assesment"
import Planning from "./form/Planning"
import apiService from "../../apiService"
import printJS from "print-js"
import moment from "moment";

const RawatInap = ({ history, detilPx }) => {

    const newInpatient = {
        id: 0,
        created_at: moment().format("YYYY-MM-DD HH:mm"),
        drug_taken: null,
        user_id: 1,
        log: false,
        diagnoses: [],
        examination: null,
        treatments: [],
        anamneses: [],
        prescribes: [],
        inpatient_room_id: detilPx.inpatient.inpatient_rooms[0].id ?? 0,
        room: detilPx.inpatient.inpatient_rooms[0].room.name,
        is_new: true
    }

    const [_detilPx, setDetilPx] = useState(detilPx)
    const [inpatientDetails, setInpatientDetails] = useState([newInpatient])
    const [tabIndex, setTabIndex] = useState(0)
    const [selectedInpatientDetailIndex, setSelectedInpatientDetailIndex] = useState(0)

    useEffect(() => {
        try {
            const r = _detilPx.inpatient.inpatient_rooms
                .map(v => v.details.map(d => ({...d, inpatient_room_id: d.id, room: v.room.name})))
                .reduce((a, b) => a.concat(b), [])

            const newList = [...r, ...(_detilPx.inpatient.exit_date ? [] : [newInpatient])].sort(function(a, b) {
                var keyA = new Date(a.created_at),
                    keyB = new Date(b.created_at);
                if (keyA < keyB) return -1;
                if (keyA > keyB) return 1;
                return 0;
            })
            setInpatientDetails(newList)
            setSelectedInpatientDetailIndex(newList.length - 1)
        }
        catch (e) {
            console.log(e)
            setInpatientDetails([newInpatient])
            setSelectedInpatientDetailIndex(0)
        }
    }, [_detilPx])

    const parentCallback = data => {
        setDetilPx({..._detilPx, [data.param]: data.data})
    }

    const nextTab = () => {
        setTabIndex(tabIndex + 1)
        window.scrollTo(0, 50)
    }
    
    const requestPrint = async () => {
        const res = await apiService.getblob(
            "/registration/print/informed_consent/" + _detilPx.id
        )
        if (res) {
            const file = new Blob([res], { type: "application/pdf" })
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file)
            //print blob
            printJS(fileURL)
        }
    }
    
    const getData = async () => {
        let param = {
            keyword: {
                visitId: _detilPx.id,
            },
            limit: 10,
            frDate: "",
            enDate: "",
        }

        const res = await apiService.post("registration", param)
        // console.log(res)
        if (res?.status === "success.") {
            setDetilPx(res.data.data[0])
            // this.context.changeDetilPx(res.data.data[0])
            // this.forceUpdate()
        }
    }
    
    let patient = detilPx
    
    return (
        <div>
            <div className="card">
                <div className="card-header">
                    <div className="row align-items-center">
                        <div className="col row">
                            <h4 className="h3 mb-0 ">Form Pemeriksaan Rawat Inap</h4>
                            <div className="ml-2 mt--1">
                                <a
                                    className="btn btn-sm btn-twitter btn-icon-only rounded-circle"
                                    onClick={getData}
                                >
                                    <i className="fa fa-refresh"
                                        style={{color: "white"}}
                                        aria-hidden="true"
                                        />
                                </a>
                            </div>
                            <div className="ml-2 mt--1">
                                <button
                                    className="btn btn-sm btn-info"
                                    onClick={() => requestPrint()}
                                >
                                    cetak persetujuan tindakan
                                </button>
                            </div>
                        </div>
                        <div
                            className={BmiCss(
                                patient.examinations[0].weight,
                                patient.examinations[0].height
                            )}
                        >
                            {BMI(
                                patient.examinations[0].weight,
                                patient.examinations[0].height
                            )}
                        </div>
                        <div
                            className={BloodPressCss(
                                patient.examinations[0].sistole,
                                patient.examinations[0].diastole
                            )}
                            style={{ marginLeft: "2%" }}
                        >
                            <b>
                                {" "}
                                {BloodPress(
                                    patient.examinations[0].sistole,
                                    patient.examinations[0].diastole
                                )}{" "}
                            </b>
                        </div>
                    </div>
                </div>
                <div className="card-body">
                    {
                        inpatientDetails.map((v, k) =>
                            <button
                                key={k}
                                style={{marginTop: 8}}
                                onClick={() => {
                                    setSelectedInpatientDetailIndex(k)
                                }}
                                className={inpatientDetails[selectedInpatientDetailIndex].created_at === v.created_at ? 'btn btn-primary' : 'btn'}>
                                {v.is_new ? <i className={'fa fa-plus'}/> : ''} {v.room} {v.created_at}
                            </button>
                        )
                    }
                </div>
                <div className="card-body">
                    <div className="tab-pane fade show active" role="tabpanel"
                         aria-labelledby="tabs-icons-text-1-tab">
                        <Tabs
                            selectedIndex={tabIndex}
                            onSelect={(tabIndex_) => setTabIndex(tabIndex_)}
                        >
                            <TabList>
                                <Tab id="Subjektif">Subjektif </Tab>
                                <Tab id="Objektif">Objektif </Tab>
                                <Tab id="Assesment">Assesment </Tab>
                                <Tab id="Planning">Planning </Tab>
                            </TabList>
                            <TabPanel tabId="Subjektif">
                                <Subjektif
                                    visit_id={detilPx.inpatient.visit_id}
                                    disabled={!!detilPx.inpatient.exit_date}
                                    inpatient={inpatientDetails[selectedInpatientDetailIndex]}
                                    on_data_saved={anamneses => {
                                        let i = inpatientDetails[selectedInpatientDetailIndex]
                                        i.anamneses = [anamneses]
                                        i.id = anamneses.visit_inpatient_detail_id
                                        console.log({anamneses, i})
                                        const filtered = inpatientDetails.filter(v => v.id !== i.id)
                                        const all = [...filtered, i].sort(function(a, b) {
                                            var keyA = new Date(a.created_at),
                                                keyB = new Date(b.created_at);
                                            if (keyA < keyB) return -1;
                                            if (keyA > keyB) return 1;
                                            return 0;
                                        })
                                        setInpatientDetails(all)
                                    }}
                                    parentCallback={parentCallback}
                                    history={history}
                                    nextTab={nextTab}
                                />
                            </TabPanel>
                            <TabPanel tabId="Objektif">
                                <Objektif
                                    existing_examination={detilPx.examinations[0]}
                                    disabled={!!detilPx.inpatient.exit_date}
                                    visit_id={detilPx.inpatient.visit_id}
                                    inpatient={inpatientDetails[selectedInpatientDetailIndex]}
                                    on_data_saved={examination => {
                                        let i = inpatientDetails[selectedInpatientDetailIndex]
                                        i.examinations = [examination]
                                        const filtered = inpatientDetails.filter(v => v.id !== i.id)
                                        const all = [...filtered, i].sort(function(a, b) {
                                            var keyA = new Date(a.created_at),
                                                keyB = new Date(b.created_at);
                                            if (keyA < keyB) return -1;
                                            if (keyA > keyB) return 1;
                                            return 0;
                                        })
                                        setInpatientDetails(all)
                                    }}
                                    patient={patient}
                                    parentCallback={parentCallback}
                                    history={history}
                                    nextTab={nextTab}
                                />
                            </TabPanel>
                            <TabPanel tabId="Assesment">
                                <Assesment
                                    existing_examination={detilPx.examinations[0]}
                                    inpatient={inpatientDetails[selectedInpatientDetailIndex]}
                                    disabled={!!detilPx.inpatient.exit_date}
                                    visit_id={detilPx.inpatient.visit_id}
                                    on_data_saved={(diagnoses, diagnostic_narativ) => {
                                        let i = inpatientDetails[selectedInpatientDetailIndex]
                                        i.diagnoses.push(diagnoses)
                                        const filtered = inpatientDetails.filter(v => v.id !== i.id)
                                        const all = [...filtered, i].sort(function(a, b) {
                                            var keyA = new Date(a.created_at),
                                                keyB = new Date(b.created_at);
                                            if (keyA < keyB) return -1;
                                            if (keyA > keyB) return 1;
                                            return 0;
                                        })
                                        setInpatientDetails(all)
                                    }}
                                    patient={patient}
                                    parentCallback={parentCallback}
                                    history={history}
                                    nextTab={nextTab}
                                />
                            </TabPanel>
                            <TabPanel tabId="Planning">
                                <Planning
                                    inpatient={inpatientDetails[selectedInpatientDetailIndex]}
                                    disabled={!!detilPx.inpatient.exit_date}
                                    visit_id={detilPx.inpatient.visit_id}
                                    patient={patient}
                                    parentCallback={parentCallback}
                                    history={history}
                                    nextTab={nextTab}
                                    getData={getData}
                                />
                            </TabPanel>
                        </Tabs>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default RawatInap